import {useEffect, useState} from "react";


import {useAppContext} from "../../../../context/Context";
import api from "../../../../utils/api";
import {setBottomBarError} from "../../../../utils/Functions";

export default function useSalesRep() {
    const [{user}, dispatch] = useAppContext(); // Récupération des informations utilisateur depuis le contexte global de l'application
    const [salesRep, setSalesRep] = useState(null); // Stocke les informations du commercial
    const [isLoading, setIsLoading] = useState(true);

    // Effet qui s'exécute lorsque l'identifiant du référent commercial change.
    useEffect(() => {
        // Fonction d'initialisation qui fait l'appel API nécessaire pour obtenir les données du référent commercial
        async function fetchSalesRep() {
            if (user?.company?.salesrep_id) {
                try {
                    const response = await api.get(`/salesrep/${user.company.salesrep_id}`);
                    setSalesRep(response.data);
                } catch (e) {
                    setBottomBarError(dispatch, e);
                }
            }
            setIsLoading(false);
        }

        fetchSalesRep().catch(console.error);
    }, [dispatch, user?.company?.salesrep_id]);

    // Retourner les informations du référent commercial et l'état de chargement
    return [{
        salesRep, // Informations sur le commercial
        isLoading, // État de chargement
    }];
}
